import React from 'react';
import FormObjectTableCell from './FormObjectTableCell';
import FormObjectToggleCell from './FormObjectToggleCell';
import FormObjectListCell from './FormObjectListCell';
import FormObjectMarkdownCell from './FormObjectMarkdownCell';
import FormObjectTextCell from './FormObjectTextCell';
import formObjectSummaryFields from '../helper';
import FormObjectStringsCell from './FormObjectStringsCell';
import FormObjectStringLinksCell from './FormObjectStringLinksCell';
import formFieldType from '../../helper';

export const formObjectTableCells = {
  boolean: FormObjectToggleCell,
  list: FormObjectListCell,
  markdown: FormObjectMarkdownCell,
  strings: FormObjectStringsCell,
  text: FormObjectTextCell,
  uuids: FormObjectStringsCell,
  emails: FormObjectStringLinksCell,
  uris: FormObjectStringLinksCell,
};

const FormObjectCells = ({
  canEdit,
  field,
  keyPrefix,
  item,
  onChange,
}) => (
  formObjectSummaryFields(field).slice(1).map((f) => {
    const ComponentCell = formObjectTableCells[formFieldType(f)] || FormObjectTableCell;
    return (
      <ComponentCell
        key={`${keyPrefix}_${f.name}`}
        field={f}
        item={item}
        canEdit={canEdit}
        onChange={onChange}
      />
    );
  })
);

export default FormObjectCells;
